"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeedTestJob = void 0;

var _LoadingMode = require("../LoadingMode");

var _Queue = require("../Queue");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SpeedTestJob = /*#__PURE__*/function (_QueueItem) {
  _inherits(SpeedTestJob, _QueueItem);

  var _super = _createSuper(SpeedTestJob);

  function SpeedTestJob(videoController) {
    var _this;

    _classCallCheck(this, SpeedTestJob);

    _this = _super.call(this);
    _this._name = "SpeedTestJob";
    _this.videoController = videoController;
    return _this;
  }

  _createClass(SpeedTestJob, [{
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vc, speed;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vc = this.videoController;
                _context.next = 3;
                return this.testSpeed();

              case 3:
                speed = this.calculate(); // TODO: remove line below, for testing only
                //speed = 5.2

                if (speed) {
                  vc._networkSpeed = speed;

                  if (speed) {
                    if (speed < 5) {
                      vc.loadingMode = _LoadingMode.LoadingMode.LOW;
                    } else if (speed < 15) {
                      vc.loadingMode = _LoadingMode.LoadingMode.MED;
                    } else if (speed < 50) {
                      vc.loadingMode = _LoadingMode.LoadingMode.HIGH;
                    } else {
                      vc.loadingMode = _LoadingMode.LoadingMode.SUPER_HIGH;
                    }
                  }

                  this.log("speed", speed, vc.loadingMode);
                } else {
                  console.warn("SpeedTestJob unabable to check speed", speed);
                }

                return _context.abrupt("return", speed);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function run() {
        return _run.apply(this, arguments);
      }

      return run;
    }() // not limiting this because it is a SPEED test

  }, {
    key: "testSpeed",
    value: function () {
      var _testSpeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var url, resp, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "https://qaapi.go.traceup.com/api/speed_test_500K.test";
                _context2.next = 4;
                return fetch(url, {
                  method: "GET",
                  mode: "cors",
                  cache: "no-store"
                });

              case 4:
                resp = _context2.sent;
                _context2.next = 7;
                return resp.blob();

              case 7:
                data = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                console.warn("SpeedTestJob error", _context2.t0);

              case 13:
                return _context2.abrupt("return", true);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }));

      function testSpeed() {
        return _testSpeed.apply(this, arguments);
      }

      return testSpeed;
    }()
  }, {
    key: "calculate",
    value: function calculate() {
      // Check performance support
      if (performance === undefined) {
        console.warm("SpeedTestJob Calculate Load Times: performance NOT supported");
        return null;
      } // Get a list of "resource" performance entries


      var resources = performance.getEntriesByType("resource");

      if (resources === undefined || resources.length <= 0) {
        console.warn("SpeedTestJob Calculate Load Times: there are NO `resource` performance records");
        return null;
      }

      var samples = [];

      var _iterator = _createForOfIteratorHelper(resources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var res = _step.value;

          if (res.name.endsWith(".test") && res.duration) {
            var ts = res.transferSize;

            if (!ts) {
              ts = 500000;
            }

            var time = res.duration / 1000;
            var bytes = ts;
            samples.push({
              bytes: bytes,
              time: time,
              bps: bytes / time
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      performance.clearResourceTimings(); // calculate average

      var totalBytes = samples.reduce(function (sum, sample) {
        return sum + sample.bytes;
      }, 0);
      var totalTime = samples.reduce(function (sum, sample) {
        return sum + sample.time;
      }, 0); // protect against divide by zero

      if (totalBytes === 0 || totalTime === 0) {
        return null;
      }

      var mbps = totalBytes / totalTime / 1000 / 1000 * 8;
      return mbps;
    }
  }]);

  return SpeedTestJob;
}(_Queue.QueueItem);

exports.SpeedTestJob = SpeedTestJob;